import axiosClient from './axiosClient';

export interface GetLogsPayload {
  module?: string;
  brandId?: string;
  locationId?: string;
  refId?: string;
  name?: string;
  action?: string;
  method?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
  isQuery?: boolean;
  query?: string;
}

const activitylogApi = {
  /** GET /activityHistory/getModules — list of available log module keys */
  getModules(): Promise<any> {
    return axiosClient.get('/activityHistory/getModules');
  },

  /** POST /activityHistory/getLogs — fetch CloudWatch logs for a module */
  getLogs(payload: GetLogsPayload): Promise<any> {
    return axiosClient.post('/activityHistory/getLogs', payload);
  },

  // Legacy alias kept so saga is not broken until slice is updated
  getActivityLogList(payload: any): Promise<any> {
    return activitylogApi.getLogs({
      module: payload.module || 'apiRequests',
      page: payload.page || 1,
      limit: payload.limit || 50,
      startDate: payload.startDate,
      endDate: payload.endDate,
      method: payload.method,
      action: payload.action,
      name: payload.name,
      brandId: payload.brandId,
      locationId: payload.locationId,
    });
  },
};

export default activitylogApi;
